import { SpeciesListScreen } from '../features/species/screens/SpeciesListScreen';

export const SpeciesListPage = () => <SpeciesListScreen />;
